import React from "react"

const generalErrorMessage = <>Sorry, we are unable to proceed with your request online.
  Please contact our Customer Service at <a href="tel:1800889933">1 800 889 933</a> or <a href="tel:+60321707300">+603 2170 7300</a>, operating hours 8:30am - 5.00pm (Monday to Friday) excluding public holidays.
  Alternatively, you may email your vehicle details (car plate and NRIC) to <a href="mailto:customer@bsompo.com.my">customer@bsompo.com.my</a> for further assistance.</>

export default {
  id: "EN",
  homeLinks: {
    home: "https://online.berjayasompo.com.my/securemotor/",
    en: "https://online.berjayasompo.com.my/securemotor/",
    bm: "https://online.berjayasompo.com.my/securemotor/insurans-kereta/",
    // home: "https://traveluat.berjayasompo.com.my/securemotor/",
    // en: "https://traveluat.berjayasompo.com.my/securemotor/",
    // bm: "https://traveluat.berjayasompo.com.my/securemotor/insurans-kereta/",
    partner: "https://travel.berjayasompo.com.my/travel-insurance/highlights/partner.html",
  },
  head: {
    title: "CIMB Secure Motor Insurance",
    description: "We offer a comprehensive and affordable car insurance plan. Enjoy a 0% interest-free instalment plan with a CIMB credit card.  Get an instant quote and renew online."
  },
  header: {
    url: '/',
    home: "Home",
    how_to_claim: "How to Claim",
    authorised_panel_workshops: "Authorised Panel Workshops",
    esi_motor_claims: "ESi-Motor Claims",
    contact_us: "Contact Us",
    partner_with_us: "Partner With Us",
    online_products: "Online Products"
  },
  breadnav: {
    step1: "Step 1",
    step2: "Step 2",
    step3: "Step 3",
    plan: "Plan",
    details: "Details",
    payment: "Payment",
  },
  docs: {
    sc_pds: "/securemotor/docs/Secure Motor PDS ENG Latest.pdf",
    sc_pw: "/securemotor/docs/Secure Motor PW ENG Latest.pdf",
    sc_tnc: "/securemotor/docs/Terms Conditions for 612 Months IPP for Secure Motor Insurance (ENG).pdf",
    sc_tnc_medical: "/securemotor/docs/complimentary-medical-benefits-campaign-secure-motor-insurance-tnc-eng.pdf",
    sc_rakan: "/securemotor/docs/Rakan_Auto.pdf",
  },
  planPage: {
    viewAll: "View all benefits",
    buyNow: "Buy Now",
    emailQuote: "Email quote",
    editQuote: "Edit quote",
    enterEmail: "Enter an email address below to save or share your quote",
    byClickSend_1: "By clicking send, you have read and agreed to our",
    byClickSend_2: "Privacy Notice",
    byClickSend_3: "",
    quoteSent: "Your quote has been sent to the email provided.",
    quoteError: "An error occured while attempting to send your quotation!",
    to: "to",
    close: "close",
    windscreenDamage: "Windscreen Damage",
    gasConversion: "Gas Conversion Kit And Tank",
    gasConversionRM200MinSumInsured: "Minimum Sum Insured is RM200",
    gasConversionMsg: "Provide cover for loss or damage to the Gas Conversion Kit and Tank of the vehicle.",
    LOUP: "Compensation For Loss Of Use Of Vehicle - E-ride/ Hailing (fee Reimbursement)",
    LOUPMsg: "Provide cover for the fees incurred for utilising approved e-ride/hailing services, while your car is being repaired by Our Approved Repairers.",
    ALP: "Auto Loan Protection",
    ALPMsg: "Provide coverage to reduce or settle the outstanding hire-purchase loan of the vehicle in the event of policyholder’s death resulting directly from an accident.",
    addOnWindscreen: "Enhanced Windscreen Coverage",
    enhancedWindscreen: "Enhanced Windscreen Coverage",
    addOnWindscreenDesc: "This cover provide protection against damage on your windscreen, window and sunroofs. Add in this coverage to prevent your windscreen claim that affecting your NCD.",
    rm200MinSumInsured: "Minimum Sum Insured is RM200",
    addOnTowing: "Unlimited Towing Cost",
    addOnTowingDesc: "Unlimited towing services anywhere within Malaysia during your policy period.",
    addOnPersonalAccident: "Personal Accident",
    addOnPersonalAccidentDesc: "Covers all passengers & driver in the event of bodily injuries, disabilities or death caused by accidents.",
    noVoluntaryExcess: "No Voluntary Excess",
    noVoluntaryExcessDesc: "There's 0 amount that you have to bear yourself for each and every claim that approve, even if the incident is not your fault. However the annual premium will be slightly higher.",
    voluntaryExcess: "3% Buy-up Voluntary Excess",
    voluntaryExcessDesc: "A voluntary excess is an amount you will have to pay upfront if you make a claim. Agreeing to pay a voluntary excess should lead to a lower annual premium.",
    thirdPartyFireTheft: "Third Party, Fire & Theft",
    additionalCoverage: "Additional Coverage",
    addOnBenefit: "Complete your coverage with optional add-on benefits:",
    liabilityOfPassenger: "Legal Liability Of Passenger",
    liabilityOfPassengerDesc: "Covers you against legal liability of your passengers for acts of negligence.",
    ncdRelief: "Current Year NCD Relief",
    ncdReliefDesc: "Protection on your current year No Claim Discount (NCD) entitlement. When a claim is made, it will compensate you the NCD amount that you are entitled on the current period of insurance.",
    betterment: "Waiver of Betterment",
    bettermentDesc: "Covers replacement for the damaged parts of your vehicle with new spare parts at no additional cost.",
    vehAccessories: "Vehicle Accessories",
    vehAccessoriesDesc: "Compensation for damage or loss of your vehicle accessories. For example: stereo system, sport rims & more.",
    strikeRiotCivil: "Strike, Riot & Civil Commotion",
    strikeRiotCivilDesc: "This add-on protects you against loss or damage to your vehicle caused by strike, riot or civil commotion.",
    IncPerils: "Inclusion of Special Perils",
    IncPerilsDesc: "Covers your vehicle against damage caused by floods, storms and other natural disasters.",
    addOnCart: "Compensation For Assessed Repair Time (CART)",
    cart: "Compensation For Assessed Repair Time",
    addOnCartDesc: "Compensation for loss of use of your vehicle based on estimated repair time as assessed by adjuster.",
    rm50maxPer7days: "RM50 Per Day Up To A Maximum Of 7 Days",
    rm100maxPer7days: "RM100 Per Day Up To A Maximum Of 7 Days",
    rm200maxPer7days: "RM200 Per Day Up To A Maximum Of 7 Days",
    rm50maxPer14days: "RM50 Per Day Up To A Maximum Of 14 Days",
    rm100maxPer14days: "RM100 Per Day Up To A Maximum Of 14 Days",
    rm200maxPer14days: "RM200 Per Day Up To A Maximum Of 14 Days",
    rm50maxPer21days: "RM50 Per Day Up To A Maximum Of 21 Days",
    rm100maxPer21days: "RM100 Per Day Up To A Maximum Of 21 Days",
    rm200maxPer21days: "RM200 Per Day Up To A Maximum Of 21 Days",
    liabilityToPassenger: "Legal Liability To Passenger",
    liabilityToPassengerDesc: "Covers you against legal liabilities sought by your passengers against you in an event of an accident due to your negligent. It is compulsory to have this benefit if you drive in Singapore.",
    addOnNatureCover: "Top Up For Full Convulsion Of Nature Cover",
    addOnNatureCoverDesc: "Covers your vehicle against damage caused by floods, storms and other natural disasters.",
    cartDays: "CART Days",
    addOnEhailing: "E-Hailing",
    addOnEhailingDesc: "Covers damage to your vehicle, liability to fare-paying passengers and third-party while providing e-hailing services.",
    showAllAddOns: "Show All Add-Ons",
    hideAddOns: "Hide Add-Ons",
    youAndRider: "You and Your Authorised Rider",
    youRiderAndPillion: "You or Your Authorised Rider and Your Pillion",
    LLTP: "Legal Liability To Pillion",
    specialPerils: "Inclusion of Special Perils",
    strikeRiot: "Strike, Riot & Civil Commotion",
    refreshQuote: "Refresh Quote",
    updateQuote: "Update Quote",
    quotationSummary: "Quotation Summary",
    sumInsured: "Sum Insured",
    basicPremium: "Basic Premium",
    marketValue: "Market Value",
    agreedValue: "Agreed Value",
    excessFee: "Excess Fee",
    allRiders: "All Riders",
    loading: "Loading",
    ncd: "No Claims Discount (NCD)",
    totalBasePremium: "Total Base Premium",
    addOns: "Add-ons",
    totalAddOns: "Total Add-ons",
    grossPremium: "Gross Premium",
    rebate: "Rebate",
    sst: "Service Tax",
    stampDuty: "Stamp Duty",
    totalPremium: "Total Premium",
    commission_disclaimer: "Include 10% commission to intermediary",
    quotationDesc: "Please read through the Product Disclosure Sheet or Policy Wording for cancellation and refund policy.",
    vehicleDetails: "Vehicle Details",
    pleaseFillInYourDetailsBelow: "Please fill in your details below",
    vehicleRegistrationNo: "Vehicle Registration No.",
    yearOfMake: "Year of Make",
    chassisNo: "Chassis No.",
    engineNo: "Engine No.",
    vehicleMake: "Vehicle Make",
    vehicleModel: "Vehicle Model",
    variant: "Variant",
    carUnderFinancing: "Car Under Financing",
    hirePurchase: "Hire Purchase",
    employerLoan: "Employer Loan",
    leasing: "Leasing",
    loanCompany: "Loan Company",
    periodOfInsurance: "Period of Insurance",
    start: "Start",
    end: "End",
    selectYourPlan: "Select Your Plan",
    pleaseSelectYourPreferredPlan: "Please select your preferred plan",
    basisSumInsured: "Basis of Sum Insured",
    recommended: "Recommended",
    comprehensive: "Comprehensive",
    thirdParty: "Third Party",
    premiumPayable: "Premium Payable",
    select: "Select",
    selected: "Selected",
    recommendedSumInsured: "Recommended Sum Insured",
    additionalCoverage: "Additional Coverage",
    completeYourCover: "Complete your coverage with optional add-on benefits:",
    planA: "Plan A",
    planB: "Plan B",
    planC: "Plan C",
    planPa1: "RM25,000/per person",
    planPa2: "RM50,000/per person",
    planPa3: "RM100,000/per person",
    planAfull: "Plan A - 25,000",
    planBfull: "Plan B - 50,000",
    planCfull: "Plan C - 100,000",
    showAllAddOns: "Show All Add-Ons",
    hideAddOns: "Hide Add-Ons",
    youAndRider: "You and Your Authorised Rider",
    youRiderAndPillion: "You or Your Authorised Rider and Your Pillion",
    LLTP: "Legal Liability To Pillion",
    specialPerils: "Inclusion of Special Perils",
    strikeRiot: "Strike, Riot & Civil Commotion",
    refreshQuote: "Refresh Quote",
    updateQuote: "Update Quote",
    back: "Back",
    next: "Next",
    quotationSummary: "Quotation Summary",
    sumInsured: "Sum Insured",
    basicPremium: "Basic Premium",
    planLoupAfull: "Plan A - 500",
    planLoupBfull: "Plan B - 1,000",
    planLoupCfull: "Plan C - 3,000",
    cartDays: "CART Days",
    bundleAddOn: "Bundle Add On: Motor N-Hancer Pack / Enhancer Pack",
    bundleAddOnMsg: "The bundle add-on offered to vehicle aged between 5 to 14 years where the premium is cheaper compared to buying each add-on individually. The individual add-ons will no longer be allowed for selection if you opt for this bundle add-on.",
    bundlePA: "Personal Accident Add On - Plan A (Sum Insured RM25,000)",
    bundleKey: "Key Replacement - Up to RM1,000",
  },
  detailPlan: {
    quotationDesc: "Customers have a choice of 6 months or 12 months 0% interest instalment plans for credit cards issued by Maybank & CIMB Bank that have a minimum payment amount of RM600.",
    policyholderDetails: "Policyholder Details",
    policyholderDesc: "Please fill in your details below",
    fullName: "Full Name (As per NRIC)",
    nationality: "Nationality",
    nricPassport: "NRIC / Passport",
    dob: "Date of Birth",
    gender: "Gender",
    male: "Male",
    female: "Female",
    mobileNo: "Mobile No. (010xxxxxxx)",
    sstNo: "SST No.",
    email: "Email",
    mailingAddress: "Mailing Address",
    address: "Address",
    postcode: "Postcode",
    city: "City",
    addState: "State",
    companyname: "Company Name",
    field_require: "This field is required",
    busregno: "Business Registration No.",
    insuredMobileNoError: "Please enter a valid mobile number",
    insuredSSTError: "Please enter a valid SST number",
    addressLine1: "Address Line 1",
    addressLine2: "Address Line 2",
    addressLine3: "Address Line 3",
    invalid_postcode: "Invalid postcode format",
  },
  summaryPlan: {
    fullName: "Full Name (As per NRIC)",
    companyname: "Company Name",
    summaryNPayment: "Summary & Payment",
    summaryDesc: "Please check and confirm the information below",
    quotationDetails: "Quotation Details",
    coverageFrom: "Coverage from ",
    coverageTo: " To ",
    coverageType: "Coverage Type",
    mainInsuredDetails: "Main Insured Details",
    periodOfInsurance: "Period of Insurance",
    excess: "Excess",
    vehicleDetails: "Vehicle Details",
    carRegNo: "Car Registration No.",
    makeModel: "Make & Model",
    variantSeries: "Variant Series",
    seatingCapacity: "Seating Capacity",
    engineCapacity: "Engine Capacity",
    yearOfMake: "Year of Make",
    chassisNo: "Chassis No.",
    engineNo: "Engine No.",
    namedDriver: "Named Driver",
    anyDriver: "Any Authorized Drivers",
    enterPromoCode: "Enter Promo Code",
    havePromoCode: "Do you have promo code?",
    promoCodeApplied: "Promo code applied.",
    apply: "Apply",
    invalidPromoCode: "Promo code is not valid!",
    field_require: "This field is required",
    payNow: "Pay Now",
    back: "Back",
    pleaseSelectPaymentMethod: "Please select your payment method",
    fullName: "Full Name (As per NRIC)",
    nationality: "Nationality",
    nricPassport: "NRIC / Passport",
    dob: "Date of Birth",
    gender: "Gender",
    male: "Male",
    female: "Female",
    mobileNo: "Mobile No. (010xxxxxxx)",
    email: "Email",
    mailingAddress: "Mailing Address",
    address: "Address",
    postcode: "Postcode",
    city: "City",
    busRegNo: "Business Registration No.",
    typeOfBusiness: "Type of Business",
    occupation: "Occupation",
    pymt_01: "CREDIT / DEBIT / FPX",
    pymt_02: "CIMB CREDIT CARD 6 MONTHS INSTALMENT PAYMENT PLAN (CONVENTIONAL CREDIT CARD ONLY)",
    pymt_03: "CIMB CREDIT CARD 12 MONTHS INSTALMENT PAYMENT PLAN (CONVENTIONAL CREDIT CARD ONLY)",
    before_finalizing: "Before finalizing the purchase, I acknowledge that CIMB Bank Berhad will receive commission for providing insurance related services. I also understand that similar product with full rebate on commission can be purchased directly from Berjaya Sompo Insurance Berhad.",
  },
  declaration: {
    declare1: `I/We have read, understood and acknowledged the `,
    declare2: ` and `,
    declare3: ` and hereby consent to the use and processing of my/our personal data by the Sompo Group of Companies and Berjaya Group of Companies (within or outside Malaysia) for the purposes as described in the Privacy Notice.`,
    declare4: "I/We understand that all product disclosure materials will be provided in digital form only.",
    declaration: "Declaration",
    privacyNotice: "Privacy Notice",
    pds: " Product Disclosure Sheet",
    tncAgree: "Please agree to the terms before proceeding",
    yes: 'Yes',
    no: 'No',
    concern: "I/We hereby give my consent to Berjaya Sompo Insurance Berhad to share my/our information (excluding information relating to my/our affairs or account) with CIMB Bank Berhad for their marketing and promotion purposes.",
    acknowledgement: "Acknowledgement",
  },
  thankyouPage: {
    paymentSuccessful: "Payment Successful",
    thankYouPayment: "Thank you for insuring your vehicle with Berjaya Sompo Insurance. Your payment has been successfully verified.",
    transactionDetails: "Transaction Details",
    orderNumber: "Order Number",
    totalAmount: "Total Amount",
    paymentMethod: "Payment Method",
    name: "Name",
    policyNo: "Policy No.",
    coveragePeriod: "Coverage Period",
    coverageTo: " To ",
    carRegNo: "Car Registration No.",
    makeSlashModel: "Make/Model",
    engineChassisNo: "Engine/Chassis Number",
    namedDriver: "Named Driver",
    anyDriver: "Any Authorized Drivers",
    importantNotice: "Important Notice",
    policyEmailPre: "A copy of your receipt and Policy Schedule will be sent to your email address at",
    policyEmailPost: "Kindly check your junk or spam email folder if you do not receive the documents in your inbox.",
    importantNotice: "Important Notice",
    downloadpolicy: "Download Policy",
    notice_01: "You may also download the receipt and policy schedule at the download button above. Please take note that the download button link will expire in 15 minutes.",
    notice_02: "To open the file, please use the following password format: the first initials of your name (as stated in the policy) in capital letters, followed by the last 6 digits of your NRIC/Passport number.",
    notice_03: "For example: If your name is John and the last 6 digits of your NRIC are 141234, your password will be J141234.",
    cross_sell_travel: "/securemotor/images/img-cross-travel.jpg",
    cross_sell_home: "/securemotor/images/img-cross-home.jpg",
  },
  failPage: {
    paymentFailed: "Payment Failed",
    paymentFailedDesc: "Your payment has not been successfully verified",
    paymentRetry: "Payment Re-try",
    orderNumber: "Order Number",
    totalAmount: "Total Amount",
    coveragePeriod: "Coverage Period",
    makeSlashModel: "Make/Model",
    engineChassisNo: "Engine/Chassis Number",
    transactionDetails: "Transaction Details",
    coverageTo: " To ",
    carRegNo: "Car Registration No.",
  },
  contact_us: {
    title: "Need Help? Contact Us",
    description: "If you have any enquiries, please contact Berjaya Sompo Insurance Berhad’s Customer Service Centre at +603 2170 7300 from 8.30 am to 5 pm (Monday to Friday - excluding public holidays) or email customer@bsompo.com.my. Alternatively, you may contact CIMB Bank Berhad at +603 6204 7788, which is available 24 hours, or email contactus@cimb.com.",
    helpline_01: "24/7 Breakdown Service for Private Car",
    helpline_02: "24/7 Breakdown Service for Motorcycle",
    customer_01: "Berjaya Sompo Customer Service",
    customer_02: "8:30 AM - 5:00 PM (Monday to Friday)",
    customer_03: "1 800 889 933 (within Malaysia)",
    customer_04: "+603 2170 7300 (overseas)",
    inMalaysia: "within Malaysia",
    oversea: "overseas",
    registration_no: "Registration No: 198001008821 (62605-U)"
  },
  form: {
    Private: "Private",
    Business: "Business",
    EV: "EV Car"
  },
  simplequote: {
    vehno: "Vehicle Registration No.",
    nric_passport: "NRIC/Passport",
    busregno: "Business Registration No.",
    fullname: "Full Name",
    fullname2: "Full Name (As per NRIC)",
    companyname: "Company Name",
    postcode: "Postcode (Vehicle Location)",
    email: "Email",
    marital_status: "Marital Status",
    occupation: "Occupation",
    type_business: "Type of Business",
    field_require: "This field is required",
    name_short: "Name is too short",
    valid_name: "Please enter a valid name",
    invalid_postcode: "Invalid postcode format",
    valid_vehno: "Please enter a valid vehicle no.",
    valid_email: "Please enter a valid email",
    dropdown_selection: "Please Select",
    submit_btn: "Get Car Insurance Quote",
    disclaimer_01: "By clicking ‘Get Car Insurance Quote’ button, you have read and agreed to our ",
    disclaimer_02: "Privacy Notice",
    disclaimer_03: " .",
    companyNameShortError: "Company Name is too short",
    invalidFormat: "Invalid format",
  },
  whySOMPO: {
    title: "Why Secure Motor Car Insurance?",
    desc: "Here’s a little more about our Secure Motor Car Insurance Malaysia.",
    why1_title: "Complimentary All Drivers Cover",
    why1_desc: "Coverage for all drivers, where no compulsory excess and nomination is required.",
    why2_title: "Complimentary Special Perils Coverage",
    why2_desc: "Provides complimentary coverage for any loss/damage to your car caused by flood, storm, landslide and more for value of up to 20% of the sum insured, capped at RM10,000.",
    // why2_title: "Full Special Perils Coverage",
    // why2_desc: "Provides coverage for any loss/damage to your car caused by flood, storm, landslide and more.",
    why3_title: "Fast Claim Approval Within 24Hours",
    why3_desc: "Enjoy claim approvals within just 24 hours for amounts of up to RM20,000 with our trusted Panel Workshops handling every step of your claim submission. Zero upfront payment required from your end.",
    // why3_title: "Agreed Value Sum Insured",
    // why3_desc: "We will reimburse you the agreed sum insured if your vehicle is damaged or lost.",
    why4_title: "12 Months Repair Warranty",
    why4_desc: "Repair warranty of 12 months against defects on the new parts replaced and workmanship carried out by our panel workshops.",
    why5_title: "Unlimited Towing Services",
    why5_desc: "Complimentary 24-hour unlimited towing services for accident and breakdown.",
    why6_title: "0% Instalment Payment Plan",
    why6_desc: "Enjoy a 0% interest-free instalment plan with a minimum payable premium as low as RM480 for 6 months and RM1,200 for 12 months using a CIMB Credit Card (Conventional Credit Card only).",
  },
  cross_sell: {
    title: "Covering every part of every day",
    desc: "Learn more about the insurance products we offer",
    button_01: "Get Quote",
    button_02: "Get Quote",
    button_03: "Get Quote",
    travel_title: "Travel Insurance",
    travel_01: "Medical, Hospital & Other Expenses up to RM 500,000.",
    travel_02: "Overseas Quarantine Allowance Due to COVID-19.",
    travel_03: "Emergency Medical Evacuation & Repatriation.",
    travel_04: "Loss of Deposit or Flight Cancellation.",
    snatch_title: "Snatch Medz+",
    snatch_01: "Accidental Death up to RM600,000*.",
    snatch_02: "Double Indemnity due to Snatch Theft or Robbery up to RM1,200,000*.",
    snatch_03: "Auto Loan Protection Coverage.",
    snatch_04: "No Claim Renewal Bonus.",
    home_title: "Secure Home",
    home_01: "Premium As Low as RM11/Month.",
    home_02: "All Risk Protection Including Fire, Flood & More.",
    home_03: "Multiple Plans Option with Up to RM60,000 Coverage.",
    home_04: "Home Content Declaration is Not Required.",
  },
  disclaimer: {
    line_01: "Note: You are at Berjaya Sompo Insurance Berhad's website & CIMB Group's privacy policy ceases to apply.",
    line_02: "Disclaimer",
    line_03: "The description of the features and benefits of the insurance product herein is not a contract of insurance and is only a brief summary of the insurance product for quick and easy reference. The complete terms and conditions of the insurance product are contained in the Policy Document of Berjaya Sompo Insurance Berhad, Registration No: 198001008821 (62605-U), the Insurer.",
    line_04: 'CIMB Bank Berhad ("Bank") accepts no responsibility, obligation or liability for this insurance product and the services provided by the Insurer.',
    line_05: "The Bank merely acts as a distributor for this insurance product.",
    line_06: "This insurance product is Berjaya Sompo Insurance Berhad's product and not a product of the Bank. Therefore this insurance product is not guaranteed by the Bank, its subsidiaries and/or its affiliates and the Insurer shall undertake the full insurance responsibilities, obligations and liabilities in respect of this insurance product."
  },
  footer: {
    address: "Address",
    online_products: "ONLINE PRODUCTS",
    contact_us: "CONTACT US",
    customer_service: {
      title: "Customer Service",
      line_01: "8:30 AM - 5:00 PM (Monday to Friday)",
      line_02: "1 800 889 933 (within Malaysia)",
      line_03: "+603 2170 7300 (overseas)",
      line_04: "24/7 Worldwide Assistance",
      line_05: "24/7 Breakdown Service for Private Car",
      line_06: "24/7 Breakdown Service for Motorcycle",
    },
    key_downloads: {
      title: "KEY DOWNLOADS",
      PDS: "Product Disclosure Sheet",
      PW: "Policy Wording",
      authorised_panel_workshops: "Authorised Panel Workshops",
      TnC_instalment: "Terms and Conditions (0% Instalment Payment Plan)",
      TnC_medical: "Terms and Conditions (Online Motor Insurance Renewal Campaign)",
      rakan_auto: "Rakan Auto",
    },
    general_policy_terms: "General Policy Terms & Condition",
    privacy_notice: "Privacy Notice",
    legal_notice: "Legal Notice",
    disclaimer: "Disclaimer",
    whistle_blowing_policy: "Whistle Blowing Policy",
    customer_servie_charter: "Customer Service Charter",
    PIDM_tips_brochure: "PIDM TIPS Brochure",
    copyright: "Copyright",
    registration_no: "Registration No",
    PIDM: {
      line_01: "The benefit(s) payable under eligible product is protected by PIDM up to limits. Please refer to",
      line_02: "PIDM's TIPS Brochure",
      line_03: "or contact Berjaya Sompo Insurance Berhad or PIDM (visit "
    },
    bnm_warning: "Please be informed that we will never ask you to provide your personal details online in order to access any product information available on our website. We urge all customers to remain vigilant against online scams."
  },
  errors: {
    errorOccured: "An error occured!",
    msg1: "Sorry, we are unable to proceed with your request online. Please contact our Customer Service at 1 800 889 933 or +603 2170 7300, operating hours 8:30am - 5.00pm (Monday to Friday) excluding public holidays. Alternatively, you may email your car details (car plate and NRIC) to customer@bsompo.com.my for further assistance.",
    msg: "We have received your request and will get back to you in 1-2 business days. If you do not receive any replies from us, please email us at customer@bsompo.com.my. Thank you.",
    msgEv1a: "Thank you for contacting us. Our team is currently reviewing your quotation request and will respond within",
    msgEv1b: "1-2 business days",
    msgEv2: "Should you have any questions or do not receive a reply within this period, please reach out to us at our dedicated website contact channel.",
    msgEv3: "We appreciate your patience and look forward to assisting you.",
    cxEmail: "customer@bsompo.com.my",
    vehicleRegistrationNo: "Vehicle Registration No.",
    nricPassport: "NRIC / Passport",
    email: "Email",
    fullName: "Full Name (As per NRIC)",
    contactNo: "Contact Number*",
    CorrAddress: "Correspondence Address*",
    occupation: "Occupation*",
    requestManual: "To request a quotation manually, please fill in the details below.",
    successRequest: "Your request has been submitted successfully!",
    submit: "Submit",
    success: "Success"
  },
  campaign: {
    desc_01: "Get Flood Coverage Up To RM30,000 or RM40 TNG E-Voucher",
    desc_02: " When You Top Up Full Convulsion Of Nature Cover",
    desc_03: "",
    desc_04: "Do you see that there’re more incidents of flash flood recently? Do you notice that there had been incidents of falling trees coupled with heavy rains happening everywhere around you? Are you aware that your car is exposed to these natural disasters everyday?",
    desc_05: "Now you can have peace of mind when you choose to renew your car insurance with Secure Motor. You can enjoy up to",
    desc_06: " RM30,000 complimentary coverage",
    desc_07: " that covers your car against loss or damage caused by natural disasters with no additional cost.",
    desc_08: "If you are afraid that the complimentary coverage is not sufficient, you may choose to protect your car with",
    desc_09: " full coverage",
    desc_10: " against natural disasters. You are entitled to a TNG voucher of",
    desc_11: " RM40",
    desc_12: " if you opt to top up full coverage for natural disasters.",
    desc_13: "Hurry, purchase Secure Motor Insurance now and enjoy the complimentary benefits or receive TNG voucher worth RM40. This campaign ends on 28 February 2025.",
    title: "Campaign Reward: Complimentary Natural Disaster Cover or TNG Voucher",
    date: "Campaign Date: 1 September 2024 to 28 February 2025",
    remark: "Follow these simple steps to participate in this campaign:",
    step_01: " Buy or renew Secure Motor online during the campaign period",
    step_02: " Once the online purchase or renewal is completed, you will automatically be enrolled in this campaign",
    product: "Product",
    GWP: "Gross Written Premium (GWP)",
    Campaign_Rewards: "Campaign Reward",
    name: "Secure Motor (Online)",
    no_min: "No Minimum Premium",
    Rewards_res: "Complimentary Natural Disaster Coverage up to RM30,000 if you do not choose to top-up coverage for full Special Perils",
    Rewards_res2: "Free RM40 TNG voucher if you choose to top-up coverage for full Special Perils",
    tnc_btn: "Terms and Conditions",
    tnc: "T&Cs apply"
  },
  maritalstatus: {
    MARRIED: "MARRIED",
    SINGLE: "SINGLE",
    DIVORCED: "DIVORCED",
    WIDOWED: "WIDOWED",
    OTHERS: "OTHERS",
  },
  back: "Back",
  next: "Next",
  selection: "Please Select",
  contact_us2: {
    title: "Need Help? Contact Us",
    description: "If you have any enquiries, please contact Berjaya Sompo Insurance Berhad’s Customer Service Centre at +603 2170 7300 from 8.30 am to 5 pm (Monday to Friday - excluding public holidays) or email customer@bsompo.com.my. Alternatively, you may contact CIMB Bank Berhad at +603 6204 7788, which is available 24 hours, or email contactus@cimb.com.",
    helpline_01: "24/7 Breakdown Service for Private Car",
    helpline_02: "24/7 Breakdown Service for Motorcycle",
    customer_01: "Berjaya Sompo Customer Service",
    customer_02: "+603 2170 7300  (8:30 AM - 5:00 PM - Monday to Friday)",
    customer_03: "CIMB Customer Service",
    customer_04: "+603 6204 7788 (24 Hours)",
    twentyfourhours: "24 Hours",
    registration_no: "Registration No: 198001008821 (62605-U)"
  },
  tinNotFound: "<strong>Notice:</strong> We were unable to locate a valid Tax Identification Number (TIN) associated with your details. As a result, no e-Invoice will be generated for this transaction. If you require an e-Invoice, please email us at <a href='mailto:customer@bsompo.com.my'>customer@bsompo.com.my</a> after completing your transaction.",
  consentModalTitle: "Acknowledgement and Consent",
  readAndAcknowledge_1: "Please read, understand, and agree to the",
  readAndAcknowledge_2: "to proceed.",
  agree: "AGREE"
}